import * as constants from './constants';

export function setCohortList(cohorts) {
  return {
    type: constants.SET_COHORT_LIST,
    cohorts,
  };
}

export function setSearchQuery(searchQuery) {
  return {
    type: constants.SET_COHORT_SEARCH_QUERY,
    searchQuery,
  };
}

export function setSortDetails(sortDetails) {
  return {
    type: constants.SET_COHORT_SORT_DETAILS,
    sortDetails,
  };
}

export function setDeploymentsList(cohortId, deployments) {
  return {
    type: constants.SET_DEPLOYMENTS_LIST,
    cohortId,
    deployments,
  };
}

export function addCohortListItem(cohort) {
  return {
    type: constants.ADD_COHORT_LIST_ITEM,
    cohort,
  };
}

export function setCohort(cohort) {
  return {
    type: constants.SET_COHORT,
    cohort,
  };
}

export function setCohortCollaborators(cohortId, collaborators) {
  return {
    type: constants.SET_COHORT_COLLABORATORS,
    cohortId,
    collaborators,
  };
}

export function archiveCohort(cohortId, finishedDate) {
  return {
    type: constants.ARCHIVE_COHORT,
    cohortId,
    finishedDate,
  };
}

export function setCohortEnrollments(cohortId, enrollments) {
  return {
    type: constants.SET_COHORT_ENROLLMENTS,
    cohortId,
    enrollments,
  };
}

export function addCohortEnrollment(cohortId, enrollment) {
  return {
    type: constants.ADD_COHORT_ENROLLMENT,
    cohortId,
    enrollment,
  };
}
